import { c as _c } from "react/compiler-runtime";
import type { Config, Id } from '../config';
import css from './details.module.scss';
import { Header } from './header';
import { Raw } from './raw';
import { Table } from './table';
interface Props {
  section: Config[Id];
  value: string;
  onChange(value: string): void;
  onSelect(id: Id): void;
}
export function Details(t0) {
  const $ = _c(15);
  const {
    section,
    value,
    onChange,
    onSelect
  } = t0;
  const {
    id,
    icon,
    title,
    text,
    data
  } = section;
  if (id === "raw") {
    let t1;
    if ($[0] !== icon || $[1] !== onChange || $[2] !== value) {
      t1 = <Raw value={value} icon={icon} onChange={onChange} />;
      $[0] = icon;
      $[1] = onChange;
      $[2] = value;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  const t1 = `${data.size} values`;
  let t2;
  if ($[4] !== icon || $[5] !== t1 || $[6] !== text || $[7] !== title) {
    t2 = <Header icon={icon} title={title} subtitle={text} chip={t1} />;
    $[4] = icon;
    $[5] = t1;
    $[6] = text;
    $[7] = title;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== onSelect || $[10] !== section) {
    t3 = <Table section={section} onSelect={onSelect} />;
    $[9] = onSelect;
    $[10] = section;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <section className={css.wrapper}>{t2}{t3}</section>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}